import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useAuth} from '../../../../auth'
import {useListView} from '../../../../../../_metronic/common/table/core/ListViewProvider'
import {ListLoading} from '../../../../../../_metronic/common/table/loading/ListLoading'
import {StockEditModalForm} from './StockEditModalForm'
import {getStockById} from '../core/_requests'

const StockEditModalFormWrapper = () => {
  const {currentUser} = useAuth()

  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: stock,
    error,
  } = useQuery(
    `${QUERIES.STOCK_LIST}-stock-${itemIdForUpdate}`,
    () => {
      return getStockById(itemIdForUpdate, currentUser)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <StockEditModalForm isStockLoading={isLoading} stock={{id: undefined}} isEdit={false} />
  }

  if (!isLoading && !error && stock) {
    return <StockEditModalForm isStockLoading={isLoading} stock={stock} isEdit={true} />
  }

  if (isLoading) {
    return <ListLoading />
  }

  return null
}

export {StockEditModalFormWrapper}
